// App colours.
export const PRIMARY_COLOR = '#F26721';

// App routes.
export const ROUTES = {
    LANDING_PAGE: '/',
    PREFACE: '/preface',
    QUIZ: '/quiz',
    REVIEW: '/review',
};

// Defines the total number of images for each category.
export const IMAGE_COUNTS = {
    PHISH_IMAGE_COUNT: 12,
    LEGIT_IMAGE_COUNT: 6,
};

// Defines how many images are chosen out of each category for the quiz.
export const IMAGE_PICK_LIMITS = {
    PHISH_PICK_LIMIT: 4,
    LEGIT_PICK_LIMIT: 2,
};
